import { render, staticRenderFns } from "./shopDate.vue?vue&type=template&id=b477b03e"
import script from "./shopDate.vue?vue&type=script&lang=js"
export * from "./shopDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports